import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchFocMasterRequest,
  fetchFocMasterSuccess,
  fetchFocMasterFailure,
} from '../slices/focMasterSlice';
import { PayloadAction } from '@reduxjs/toolkit';
function fetchFocMasterApi(): Promise<any> {
  return fetch('/api/foc-master').then((res) => res.json());
}
function* handleFetchFocMaster(): Generator<any, void, any> {
  try {
    const data = yield call(fetchFocMasterApi);
    yield put(fetchFocMasterSuccess(data));
  } catch (error: any) {
    yield put(fetchFocMasterFailure(error.message));
  }
}
export function* focMasterSaga(): Generator {
  yield takeLatest(fetchFocMasterRequest.type, handleFetchFocMaster);
}
